module.exports = "../../app/cells/components/new_menu_cell.rb";